// extracted by mini-css-extract-plugin
export default {"LayoutHeader":"Layout-module__LayoutHeader__x23GPBo"};